import { Card, DownloadLink, onDownloadLinkClick, Table } from 'components/core-v2'

import { DOWNLOAD_API } from '@/api'
import { plural } from '@/utilities/plural'

import {
  useFilteredGetByTenantAccountDashboardQuery,
  useNoteFilters
} from '../../utils/useFilteredNotes'
import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'
import { Loading } from './Loading'

export const NotesTable = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()
  const { clientType, currencyCode, noteIds } = useNoteFilters()

  if (isLoading || isFetching) return <Loading />

  const noteCount = data.notes.length

  const onDownloadClick = () => {
    onDownloadLinkClick({
      url: DOWNLOAD_API.exportNotes,
      filename: 'notes.csv',
      method: 'POST',
      body: {
        ids: noteIds && noteIds.slice(1).split(','),
        currencyCode,
        clientType
      }
    })
  }

  return (
    <Card.Wrapper>
      <Card.Header alignChildrenRight title={`${noteCount} ${plural('Note', noteCount)}`}>
        <DownloadLink onClick={onDownloadClick}>Export notes report</DownloadLink>
      </Card.Header>
      <Table
        data-private
        agGridProps={{
          columnDefs: COLUMN_DEFS,
          defaultColDef: DEFAULT_COLUMN_OPTIONS,
          headerHeight: 60,
          rowData: data.notes,
          rowHeight: 44
        }}
        height="400px"
      />
    </Card.Wrapper>
  )
}
